import React from 'react';
import MapView from './MapView';
import CampoMilitar from '../images/campo_militar.jpeg';
import Bicicleta from '../images/bicicleta.jpeg';
import AccessibilidadImg from '../images/accessibilidad.jpeg';
import PhotosImg from '../images/photos.jpeg';
import Comp from '../images/Comp.jpg';
import Recre from '../images/Recre.jpg';
import Inf from '../images/Inf.jpg';

const EventDetails = () => {
  return (
    <>
      <section className="event-details">
        <div className="details-container">
          <div className="details-grid">
            <div className="detail-card">
              <div className="card-image">
                <img src={AccessibilidadImg} alt="Accesibilidad" className="detail-image" style={{ objectFit: 'cover' }} />
              </div>
              <h3>Accesibilidad</h3>
              <ul>
                <li>Estacionamiento</li>
                <li>Cafetería</li>
                <li>Mecánico</li>
                <li>Sanitario</li>
                <li>Atención Médica</li>
              </ul>
            </div>
            
            <div className="detail-card">
              <div className="card-image">
                <img src={PhotosImg} alt="Puntos de Foto" className="detail-image" style={{ objectFit: 'cover' }} />
              </div>
              <h3>Fotografía</h3>
              <p>Disfruta de las mejores vistas del la ciudad de Puebla.</p>
              <p>Distintos puntos de toma de fotografía disponibles durante el recorrido.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="routes">
        <h2>Rutas</h2>
        <div className="routes-container">
          <div className="route-card">
            <img src={Comp} alt="Ruta competitiva" className="route-image" />
            <h3>20 km Ruta competitiva</h3>
          </div>
          <div className="route-card">
            <img src={Recre} alt="Rodada recreativa" className="route-image" />
            <h3>10 km Rodada recreativa</h3>
          </div>
          <div className="route-card">
            <img src={Inf} alt="Circuito Infantil" className="route-image" />
            <h3>3 km Circuito Infantil</h3>
          </div>
        </div>
      </section>

      <section className="location">
        <h2>Ubicación</h2>
        <div className="location-content">
          <div className="location-item">
            <div className="location-image">
              <MapView lat={19.027610778808594} lng={-98.15584564208984} zoom={17} />
            </div>
            <h3>Acceso Principal</h3>
            <p>25ª Zona Militar - Campo Militar</p>
            <p>Ejército Mexicano</p>
          </div>
          <div className="location-item">
            <div className="location-image">
              <img 
                src={CampoMilitar} 
                alt="Instalaciones 25ª Z.M. - Pista de Atletismo" 
                className="location-main-image"
                style={{ height: '320px', width: '100%', objectFit: 'cover' }}
              />
            </div>
            <h3>Dirección Completa</h3>
            <p>
              25/a. Z.M. C. 16 de Septiembre 1, Ignacio Zaragoza,<br />
              72380 Heroica Puebla de Zaragoza, Pue.<br />
              (Interior 25/a. Z.M.)
            </p>
          </div>
        </div>
      </section>

      <section className="event-info">
        <h2>CUANDO NOS VEMOS</h2>
        <div className="event-info-content">
          <div className="event-info-image">
            <div 
              className="event-main-image"
              style={{ 
                backgroundImage: `url(${Bicicleta})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '450px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#0b2b1a',
                fontWeight: 'bold',
                textShadow: '0 1px 2px rgba(255,255,255,0.8)'
              }}
            >
            </div>
          </div>
          <div className="info-item">
            <strong>FECHA:</strong> 9 de noviembre del 2025
          </div>
          <div className="info-item">
            <strong>HORA:</strong> 10:00 am
          </div>
          <div className="info-item">
            <strong>ACCESO:</strong> de 08:30 a 10:00
          </div>
          <div className="info-item">
            <strong>LUGAR:</strong> Interior de la 25/a. Zona Militar<br />
            (Escuela de Mando del Ejército y Fuerza Aérea)<br />
            Heroica Puebla de Zaragoza, Pue.
          </div>
        </div>
      </section>
    </>
  );
};

export default EventDetails;
